import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=8420e7f6&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8420e7f6",
  null
  
)

export default component.exports